import { render, staticRenderFns } from "./ListProductPageComprar.vue?vue&type=template&id=2188ca33"
import script from "./ListProductPageComprar.vue?vue&type=script&lang=js"
export * from "./ListProductPageComprar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports